/**
 * F39 (design-polish) — placement status → `PlacementStateBadge` narrowing.
 *
 * The canonical `PlacementStatus` (`@bravemove/types`) carries `cancelled`, which the
 * `PlacementStateBadge` primitive does NOT model (its closest variant is
 * `suspended_by_admin`). Rather than misuse the badge, the admin pages render the
 * primitive for every status it DOES support and fall back to a `StatusChip` for
 * `cancelled`. This predicate narrows `PlacementStatus` to the badge's
 * `PlacementState` for the supported cases.
 */
import type { PlacementState } from '@bravemove/ui-web';
import type { PlacementStatus } from '@bravemove/types';

/**
 * Every `PlacementStatus` except `cancelled` is a valid `PlacementState`. Returns
 * `true` (and narrows) for the supported cases; `false` for `cancelled`.
 */
export function isPlacementBadgeState(
  status: PlacementStatus,
): status is PlacementStatus & PlacementState {
  return status !== 'cancelled';
}
